import { useLocation } from 'react-router-dom';
import { AppTester } from 'supporting';

const getLang = (currentLang: string | null) =>  {
  if (!currentLang || currentLang === null ||
      currentLang.toString() === '[object Object]' || 
      currentLang === 'ru') {
    return 'en'
  }
  return currentLang;
}

export const useOnlinesParam = (): any => {
    const location = useLocation();
    const isDODOnlines = location.pathname.startsWith("/dop") || AppTester.isOnlines();

    const setUserParam = () => {
      if (isDODOnlines) {
        const param = location.search;
        const lang = localStorage.getItem('lang')
        if (param.includes('utm_source')) {
          sessionStorage.setItem('userParam', param);
          return;
        }
        sessionStorage.setItem('userParam', `?lang=${getLang(lang)}`);
      }
    }
    
  return [setUserParam]
}import { useLocation } from 'react-router-dom';
import { AppTester } from 'supporting';

const getLang = (currentLang: string | null) =>  {
  if (!currentLang || currentLang === null ||
      currentLang.toString() === '[object Object]' || 
      currentLang === 'ru') {
    return 'en'
  }
  return currentLang;
}

export const useOnlinesParam = (): any => {
    const location = useLocation();
    const isDODOnlines = location.pathname.startsWith("/dop") || AppTester.isOnlines();

    const setUserParam = () => {
      if (isDODOnlines) {
        const param = location.search;
        const lang = localStorage.getItem('lang')
        if (param.includes('utm_source')) {
          sessionStorage.setItem('userParam', param);
          return;
        }
        sessionStorage.setItem('userParam', `?lang=${getLang(lang)}`);
      }
    }
    
  return [setUserParam]
}